const us = {
  channel: {
    id: 'united_states'
  },
  name: 'United States',
  external: 'https://us.tretorn.com'
};

export default [us];
